import { Platform } from 'react-native';
import { isDevice } from 'expo-device';

async function setUser({ id, email, name }: { id: string; email?: string; name?: string }) {
	const Purchases = await importPurchases();
	if (!Purchases) {
		return;
	}

	const { logIn, setEmail, setDisplayName } = Purchases;

	await logIn(id);

	return Promise.all([setEmail(email || null), setDisplayName(name || null)]);
}

async function clearUser() {
	const Purchases = await importPurchases();
	if (!Purchases) {
		return;
	}

	return Purchases.logOut();
}

export { setUser, clearUser };

// Required lazy import due to the error that blocked development on non-real devices
export function importPurchases() {
	if (!isDevice || Platform.OS === 'web') {
		// Purchases working on real devices only'
		return;
	}

	return import('react-native-purchases').then((imported) => imported.default);
}
